"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerController = void 0;
const fym_lib_1 = require("@faceyourmanga/fym-lib");
const PublicDrawerController_1 = require("./PublicDrawerController");
const drawableToIntermediates_1 = require("../intermediate/drawableToIntermediates");
const intermediateToRender_1 = require("../intermediate/intermediateToRender");
/**
 * Da chiedere a gianni:
 * findCategoryOfElementForSet non dovrebbe restitutire un array siccome un elemento puòà stare in più categorie dello stesso set? quindi realCategory è scorretto?
 */
class DrawerController {
    /**
     * Temp element require category and svg
     *
     * @param resources
     * @param setId
     * @param tempOrExisElement
     * @param tempOrExisElementTransformOrPalette
     * @param tempOrExisElementAAppliedTransformOrPalette
     */
    static async testTemporanyElement(resources, setId, tempOrExisElement, tempOrExisElementTransform, tempOrExisElementAppliedTransform, tempRequiredElementOfCategories, tempRequiredElementOfCategoriesElement) {
        let element = { ...tempOrExisElement, visible: true /* Force visibility for test */ };
        let transform = tempOrExisElementTransform
            ? { ...tempOrExisElementTransform }
            : undefined;
        let parsedResources = { ...resources };
        if (typeof tempOrExisElement.svg === 'undefined')
            throw new Error('Cannot test element because SVG is not present');
        if (typeof tempOrExisElement.categories === 'undefined' || tempOrExisElement.categories.length === 0)
            throw new Error('Cannot test element because Category is not present');
        if (transform && typeof transform.id === 'undefined') {
            // Add transform into resources if is temporany
            transform.id = 'tmpTransform';
            parsedResources = {
                ...parsedResources,
                transform: { ...parsedResources.transform, tmpTransform: { ...transform } },
            };
            // Override element transform
            element.transform = 'tmpTransform';
        }
        if (typeof tempOrExisElement.id === 'undefined') {
            // Add element into category
            element.id = 'tmpElement';
            const elementCategory = parsedResources.category[element.categories[0]];
            elementCategory.elements = [...elementCategory.elements, 'tmpElement'];
            parsedResources = {
                ...parsedResources,
                category: { ...parsedResources.category, [elementCategory.id]: elementCategory },
            };
        }
        parsedResources = {
            ...parsedResources,
            element: { ...parsedResources.element, [element.id]: element },
        };
        try {
            fym_lib_1.findCategoryOfElementForSet(parsedResources, element.id, setId);
        }
        catch {
            throw new Error('Cannot test element because Category is not part of setId');
        }
        const toDraw = new PublicDrawerController_1.PublicDrawerController(parsedResources, setId);
        if (typeof tempRequiredElementOfCategories !== 'undefined' && tempRequiredElementOfCategories.length > 0) {
            tempRequiredElementOfCategories.forEach(categoryId => {
                if (parsedResources.category[categoryId].elements.length > 0) {
                    const randomElementId = typeof tempRequiredElementOfCategoriesElement !== 'undefined' &&
                        typeof tempRequiredElementOfCategoriesElement[categoryId] !== 'undefined'
                        ? tempRequiredElementOfCategoriesElement[categoryId]
                        : DrawerController.getRandomElementIdByCategoryId(parsedResources, categoryId);
                    if (randomElementId) {
                        toDraw.addElement(parsedResources, parsedResources.element[randomElementId], undefined, tempOrExisElementAppliedTransform ? tempOrExisElementAppliedTransform : undefined);
                    }
                }
            });
        }
        toDraw.addElement(parsedResources, element, undefined, tempOrExisElementAppliedTransform ? tempOrExisElementAppliedTransform : undefined);
        const data = toDraw.getData(resources, setId);
        if (data) {
            const intermediates = drawableToIntermediates_1.drawableToIntermediates(parsedResources, data);
            return intermediateToRender_1.intermediateToRenderer(parsedResources, setId, intermediates);
        }
        return [];
    }
    static getRandomElementIdByCategoryId(resources, category_id, onlyThisElements, rand) {
        if (typeof rand === 'undefined') {
            rand = 0;
        }
        if (typeof onlyThisElements !== 'undefined') {
            if (onlyThisElements.length <= 0)
                return undefined;
            const maxElements = onlyThisElements.length - 1;
            return onlyThisElements[Math.round(rand * maxElements)];
        }
        if (resources.category[category_id].elements.length <= 0)
            return undefined;
        const maxElements = resources.category[category_id].elements.length - 1;
        return resources.category[category_id].elements[Math.round(rand * maxElements)];
    }
}
exports.DrawerController = DrawerController;
